import { BodyDefault } from '@npco/zeller-design-system'

import { ReactComponent as CheckmarkIcon } from 'assets/svg/checkmark.svg'

import { StyledLi, StyledUl } from './SignUpSidebarItemList.styled'

interface SignUpSidebarItemListProps {
  items: string[]
}

export const SignUpSidebarItemList = ({
  items,
}: SignUpSidebarItemListProps) => {
  return (
    <StyledUl>
      {items.map((item) => {
        return (
          <StyledLi key={item}>
            <CheckmarkIcon />
            <BodyDefault>{item}</BodyDefault>
          </StyledLi>
        )
      })}
    </StyledUl>
  )
}
